export default __webpack_public_path__ + "static/media/fire.2ef756ca.jpg";